import { render, staticRenderFns } from "./laporan.vue?vue&type=template&id=0bbb5ea0&scoped=true&"
import script from "./laporan.vue?vue&type=script&lang=js&"
export * from "./laporan.vue?vue&type=script&lang=js&"
import style0 from "./laporan.vue?vue&type=style&index=0&id=0bbb5ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbb5ea0",
  null
  
)

export default component.exports